import { sub, compareAsc, differenceInMilliseconds } from 'date-fns';
import * as api from '../../config/api';
import { setMemberAlert } from '../../utils/alert';
import {
  GET_MEMBER_DATA_SUCCEEDED,
  GET_MEMBER_DATA_FAILED,
  SAVE_SIGN_UP_SESSION,
  CLEAR_SIGN_UP_SESSION,
  // MEMBER_LOGIN_SUCCEEDED,
  MEMBER_LOGIN_FAILED,
  MEMBER_LOGOUT_SUCCEEDED,
  MEMBER_LOGOUT_FAILED,
  SEND_MEMBER_RESET_EMAIL_START,
  SEND_MEMBER_RESET_EMAIL_SUCCEEDED,
  SEND_MEMBER_RESET_EMAIL_FAILED,
  GET_MEMBER_LOCATION_INFO_START,
  GET_MEMBER_LOCATION_INFO_SUCCEEDED,
  GET_MEMBER_LOCATION_INFO_FAILED,
  MEMBERS_LOAD_SUCCESS,
  MEMBERS_LOADING,
  // SIGNUP_SUCCESS,
  VALID_INVITE,
  MEMBER_SAVE_CREDENTIALS,
  FETCH_REQUEST_START,
  FETCH_REQUEST_SUCCESS,
  FETCH_REQUEST_FAILED,
  UPDATE_REQUEST_START,
  UPDATE_REQUEST_SUCCESS,
  UPDATE_REQUEST_FAILED,
  // Register
  SEND_REGISTER_START,
  SEND_REGISTER_SUCCEEDED,
  SEND_REGISTER_FAILED,

  // Job title list request
  GET_TITLE_LIST_START,
  GET_TITLE_LIST_SUCCEEDED,
  GET_TITLE_LIST_FAILED,
  GET_DEPS_LIST_START,
  GET_DEPS_LIST_SUCCEEDED,
  GET_DEPS_LIST_FAILED,
  // TOTP
  CELL_VERIFICATION_INIT,
  CELL_VERIFICATION_ATTEMPT,
  CELL_VERIFICATION_RESPONSE,
  CELL_VERIFICATION_ERROR,

  // Country list
  GET_COUNTRY_LIST_START,
  GET_COUNTRY_LIST_SUCCESS,
  GET_COUNTRY_LIST_FAILED,

  // tz list
  GET_TZLIST_START,
  GET_TZLIST_SUCCESS,
  GET_TZLIST_FAILED,

  // Member info
  GET_MEMBER_INFO_START,
  GET_MEMBER_INFO_SUCCESS,
  GET_MEMBER_INFO_FAILED,
  PUT_MEMBER_INFO_START,
  PUT_MEMBER_INFO_SUCCESS,
  // PUT_MEMBER_INFO_FAILED,
  GET_MEMBER_SETTING_SUCCESS,
  PUT_MEMBER_SETTING_SUCCESS,

  // Avatar update
  PUT_AVATAR_UPDATE_START,
  PUT_AVATAR_UPDATE_SUCCESS,
  PUT_AVATAR_UPDATE_FAILED,
  FETCH_ROLES_START,
  FETCH_ROLES_SUCCESS,
  FETCH_ROLES_FAILED,

  //Notifications setting
  FETCH_NOTIFICATIONS_SETTING_START,
  FETCH_NOTIFICATIONS_SETTING_SUCCESS,
  FETCH_NOTIFICATIONS_SETTING_FAILED,
  PUT_NOTIFICATIONS_SETTING_START,
  PUT_NOTIFICATIONS_SETTING_SUCCESS,
  PUT_NOTIFICATIONS_SETTING_FAILED,

  // Terms and conditions
  // GET_TERMS_AND_CONDITIONS_START,
  // GET_TERMS_AND_CONDITIONS_SUCCESS,
  // GET_TERMS_AND_CONDITIONS_FAILED,
  SET_MEMBER_ALERT,
  SHOW_COUNTDOWN,
  SET_COUNTDOWN_TIMER,
  AUTO_LOGOUT,
  CLEAR_AUTO_LOGOUT,
  GET_ALL_MEMBERS,
} from '../actionTypes/member.js';

import { subscribeToSSE, unsubscribeSSE } from './event';
import { getCalendarColors } from './schedule_event';

const apiUrl = api.apiUrl;
const sessionExpirationThreshold =
  process.env.REACT_APP_SESSION_EXPIRATION_THRESHOLD_MINUTES;

export const saveSignUpSession = (payload) => ({
  type: SAVE_SIGN_UP_SESSION,
  payload,
});
export const clearSignUpSession = (payload) => ({
  type: CLEAR_SIGN_UP_SESSION,
  payload,
});
export const forgotPasswordRequestStart = () => ({
  type: SEND_MEMBER_RESET_EMAIL_START,
});
export const forgotPasswordRequestSucceeded = () => ({
  type: SEND_MEMBER_RESET_EMAIL_SUCCEEDED,
});
export const forgotPasswordRequestFailed = (payload) => ({
  type: SEND_MEMBER_RESET_EMAIL_FAILED,
  payload,
});
export const getMemberLocationInfoStart = (payload) => ({
  type: GET_MEMBER_LOCATION_INFO_START,
  payload,
});
export const getMemberLocationInfoSucceeded = (payload) => ({
  type: GET_MEMBER_LOCATION_INFO_SUCCEEDED,
  payload,
});
export const getMemberLocationInfoFailed = (payload) => ({
  type: GET_MEMBER_LOCATION_INFO_FAILED,
});

export const login = (formData) => (dispatch) => {
  const url = `${apiUrl}/member/login`;
  console.log(url);
  api
    .POST(url, formData, { 'Content-Type': 'application/json' })
    .then((res) => {
      console.log(res);
      // dispatch(memberLoginSucceeded(res));
      if (res) {
        dispatch(getMember());
      } else {
        dispatch(
          memberLoginFailed(
            `Either the Email or password you have entered are not correct!`
          )
        );
      }
    })
    .catch((err) => {
      let errMsg = 'An unexpected error occurred, please try again later.';
      if (err && err.res && err.res.status === 403) {
        errMsg = 'Your account is disabled';
      }
      dispatch(memberLoginFailed(errMsg));
    });
};

export const logout = (member_id, session_id) => (dispatch) => {
  const url = `${apiUrl}/member/${member_id}/logout/${session_id}`;
  console.debug('Logout action fired');
  api
    .POST(url, { 'Content-Type': 'application/json' })
    .then((res) => {
      // Close connection to SSE
      dispatch(memberLogoutSucceeded(res));
      unsubscribeSSE();
    })
    .catch((err) => {
      dispatch(memberLogoutFailed);
    });
};

export const sendForgotEmail = (formData) => (dispatch) => {
  const url = `${apiUrl}/member/forgot`;
  dispatch(forgotPasswordRequestStart());
  api
    .POST(url, formData, { 'Content-Type': 'application/json' })
    .then((res) => {
      if (res.success) {
        dispatch(forgotPasswordRequestSucceeded());
      } else {
        dispatch(forgotPasswordRequestFailed(res));
      }
    })
    .catch((err) => {
      const status = (err && err.res && err.res.status) || null;
      let message = '';
      if (status === 400) {
        message = 'Please Provide Email Address!';
      } else if (status === 404) {
        message = 'Email not Found!';
      } else if (status === 409) {
        message = 'Email already sent. Please check your Email.';
      } else if (status === 500) {
        message = 'Something went wrong when sending Email!';
      }
      dispatch(forgotPasswordRequestFailed(message));
    });
};
export const validateForgotKey = (forgotKey) => (dispatch) => {
  const url = `${apiUrl}/member/reset-password/${forgotKey}`;
  api
    .GET(url)
    .then((res) => {
      if (res.member_id) {
        dispatch(fetchRequestSuccess());
      } else {
        dispatch(fetchRequestFailed('Unable to Validate Key.'));
      }
    })
    .catch((err) => {
      const status = (err && err.res && err.res.status) || null;
      let message = '';
      if (status === 400) {
        message = 'Please provide forgot key!';
      } else if (status === 404) {
        message = 'Invalid key check email!';
      } else if (status === 410) {
        message = 'Reset link expired!';
      } else if (status === 500) {
        message = 'Internal Server Error!';
      }
      dispatch(fetchRequestFailed(message));
    });
};

export const resetPassword = (formData) => (dispatch) => {
  const url = `${apiUrl}/member/reset-password/${formData.forgot_key}`;
  dispatch(updateRequestStart());
  const formDataString = JSON.stringify(formData);
  api
    .POST(url, formDataString, { 'Content-Type': 'application/json' })
    .then((res) => {
      if (res.success) {
        dispatch(updateRequestSuccess());
      } else {
        dispatch(updateRequestFailed('Failed to Update Password.'));
      }
    })
    .catch((err) => {
      const status = (err && err.res && err.res.status) || null;
      let message = '';

      if (status === 410) {
        message = 'Link Expired!';
      } else if (status === 500) {
        message = 'Something went wrong.';
      }
      dispatch(updateRequestFailed(message));
    });
};

export const changePassword = (formData) => (dispatch) => {
  const url = `${apiUrl}/member/change-password`;
  dispatch(updateRequestStart());
  const formDataString = JSON.stringify(formData);
  api
    .POST(url, formDataString, { 'Content-Type': 'application/json' })
    .then((res) => {
      if (res.success) {
        dispatch(updateRequestSuccess());
      } else {
        dispatch(updateRequestFailed('Failed to Update Password.'));
      }
    })
    .catch((err) => {
      const status = (err && err.res && err.res.status) || null;
      let message = '';
      if (status === 400) {
        message = 'Please fill all fields!';
      } else if (status === 409) {
        message = 'New password should must be different!';
      } else if (status === 404) {
        message = 'Current password is incorrect!';
      } else if (status === 500) {
        message = 'Something went wrong!';
      }
      dispatch(updateRequestFailed(message));
    });
};

const setCountdown = (dispatch, expiration_date) => {
  let now = new Date();
  const threshold = sub(expiration_date, {
    minutes: sessionExpirationThreshold || 2,
  });
  console.debug(`Exp Date: ${expiration_date}`);
  console.debug(`Threshold: ${threshold}`);
  console.debug(`Now Date: ${now}`);
  console.debug(`Compare ASC: ${compareAsc(now, threshold)}`);
  console.debug(
    `Difference in MS: ${differenceInMilliseconds(now, threshold)}`
  );
  console.debug(
    `Difference in MS: ${differenceInMilliseconds(threshold, now)}`
  );
  let later = 0;
  if (compareAsc(now, threshold) < 0) {
    later = differenceInMilliseconds(threshold, now);
  }
  console.debug(`Later: ${later}`);
  dispatch({ type: SHOW_COUNTDOWN, payload: false });
  const countdownTimer = setTimeout(() => {
    dispatch({ type: SHOW_COUNTDOWN, payload: true });
  }, later);
  dispatch({ type: SET_COUNTDOWN_TIMER, payload: countdownTimer });
};

export const getNewExpiration = () => (dispatch) => {
  // console.log('Get member fired');
  const url = `${apiUrl}/valid-session`;

  api
    .PUT(url)
    .then((res) => {
      if (res.member_id) {
        dispatch({ type: GET_MEMBER_DATA_SUCCEEDED, payload: res });
        setCountdown(dispatch, new Date(res.expiration_date));
      } else {
        dispatch({ type: GET_MEMBER_DATA_FAILED });
      }
    })
    .catch((error) => {
      dispatch({ type: GET_MEMBER_DATA_FAILED });
      console.error(error);
    });
};

export const getMember = () => (dispatch) => {
  // console.log('Get member fired');
  const url = `${apiUrl}/valid-session`;

  api
    .GET(url)
    .then((res) => {
      if (res && res.member_id) {
        dispatch({ type: GET_MEMBER_DATA_SUCCEEDED, payload: res });
        setCountdown(dispatch, new Date(res.expiration_date));
        // Request member details
        dispatch(getMemberInfo());
        //  Here we subscribe to event source
        dispatch(getCalendarColors());

        subscribeToSSE(res.member_id);
        console.log('SESSION ID', res.session_id);
      } else {
        dispatch({ type: GET_MEMBER_DATA_FAILED });
      }
    })
    .catch((error) => {
      dispatch({ type: GET_MEMBER_DATA_FAILED });
      console.error(error);
    });
};

// Get Member Location Information
export const getMemberLocationInfo = () => (dispatch) => {
  const url = `${apiUrl}/api/client/info`;
  dispatch(getMemberLocationInfoStart());
  api
    .GET(url)
    .then((res) => {
      dispatch(getMemberLocationInfoSucceeded(res));
    })
    .catch((error) => {
      dispatch(getMemberLocationInfoFailed(error));
      console.error(error);
    });
};

export const getMembers = (data) => (dispatch) => {
  let url = `${apiUrl}/member/search?search_key=${data.search_key}`;
  if (data.group_id) url = `${url}&exclude_group_id=${data.group_id}`;
  dispatch({ type: MEMBERS_LOADING });
  api
    .GET(url)
    .then((res) => {
      // console.log('Get Members from shareprocess modal returned', res.members);
      dispatch(loadMemebersSuccess(res.members));
    })
    .catch((error) => {
      console.log(error);
      dispatch(loadMemebersSuccess([]));
    });
};

export const getAllMembers = (data) => async (dispatch) => {
  let url = `${apiUrl}/member/search?search_key=`;
  try {
    const res = await api.GET(url);
    dispatch({ type: GET_ALL_MEMBERS, payload: res.members });
  } catch (e) {}
};

export const getMemberInfo = () => {
  return (dispatch) => {
    console.log('Requestng member info');
    dispatch({ type: GET_MEMBER_INFO_START });
    const url = `${apiUrl}/member/info`;
    api
      .GET(url)
      .then((res) => {
        if (res.success) {
          console.log('Response from member info endpoint', res.data);
          dispatch({ type: GET_MEMBER_INFO_SUCCESS, payload: res.data });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_MEMBER_INFO_FAILED, payload: error });
      });
  };
};

export const getMemberSetting = () => {
  return (dispatch) => {
    console.log('Requestng member setting');
    dispatch({ type: GET_MEMBER_INFO_START });
    const url = `${apiUrl}/member/setting`;
    api
      .GET(url)
      .then((res) => {
        if (res.success) {
          console.log('Response from member info endpoint', res.data);
          dispatch({ type: GET_MEMBER_SETTING_SUCCESS, payload: res.data });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_MEMBER_INFO_FAILED, payload: error });
      });
  };
};

export const putMemberInfo = (formData) => {
  return (dispatch) => {
    console.log('Submitting member info');
    dispatch({ type: PUT_MEMBER_INFO_START });
    const url = `${apiUrl}/member/info`;
    return api
      .PUT(url, JSON.stringify(formData), {
        'Content-Type': 'application/json',
      })
      .then((res) => {
        if (res.success) {
          console.log('Response after submitting profile edit form', res.data);
          dispatch({ type: PUT_MEMBER_INFO_SUCCESS, payload: res.data });
          // return true;

          const message = 'Profile information updated successfully';
          const payload = setMemberAlert(res, true, message);
          dispatch(setReduxMemberAlert(payload));
        } else {
          const message = 'Failed to update profile information!';
          const payload = setMemberAlert(null, false, message);
          dispatch(setReduxMemberAlert(payload));
        }
      })
      .catch((error) => {
        // dispatch({ type: PUT_MEMBER_INFO_FAILED, payload: error });
        const payload = setMemberAlert(error, false);
        dispatch(setReduxMemberAlert(payload));
        // return false;
      });
  };
};

export const putMemberSetting = (formData) => {
  return (dispatch) => {
    console.log('Submitting member setting');
    dispatch({ type: PUT_MEMBER_INFO_START });
    const url = `${apiUrl}/member/setting`;
    return api
      .PUT(url, JSON.stringify(formData), {
        'Content-Type': 'application/json',
      })
      .then((res) => {
        if (res.success) {
          console.log(
            'Response after submitting profile setting form',
            res.data
          );
          dispatch({ type: PUT_MEMBER_SETTING_SUCCESS, payload: res.data });
          // return true;
          const message = 'Profile setting updated successfully';
          const payload = setMemberAlert(res, true, message);
          dispatch(setReduxMemberAlert(payload));
        } else {
          const message = 'Failed to update profile setting!';
          const payload = setMemberAlert(null, false, message);
          dispatch(setReduxMemberAlert(payload));
        }
      })
      .catch((error) => {
        // dispatch({ type: PUT_MEMBER_INFO_FAILED, payload: error });
        const payload = setMemberAlert(error, false);
        dispatch(setReduxMemberAlert(payload));
        // return false;
      });
  };
};

export const ValidInvite = (inviteKey) => {
  const url = `${apiUrl}/member/invite/${inviteKey}`;
  return api.GET(url);
};

export const RegisterMember = (data, inviteKey) => {
  if (inviteKey) {
    inviteKey = `/${inviteKey}`;
  }
  const url = `${apiUrl}/member/register${inviteKey}`;
  // const newData = {
  //   ...data,
  //   state: data.sub_local0 ? data.sub_local0 : '',
  // };
  return api.POST(url, data, {});
};

// export const memberLoginSucceeded = (payload) => ({
//   type: MEMBER_LOGIN_SUCCEEDED,
//   payload,
// });
export const memberLoginFailed = (loginErr) => ({
  type: MEMBER_LOGIN_FAILED,
  payload: {
    loginErr,
  },
});
export const memberLogoutSucceeded = (payload) => ({
  type: MEMBER_LOGOUT_SUCCEEDED,
  payload,
});
export const memberLogoutFailed = (payload) => ({
  type: MEMBER_LOGOUT_FAILED,
  payload,
});
export const getMemberDataSucceeded = (payload) => ({
  type: GET_MEMBER_DATA_SUCCEEDED,
  payload,
});

export const loadMemebersSuccess = (payload) => ({
  type: MEMBERS_LOAD_SUCCESS,
  payload,
});

export const loadInvite = (payload) => ({
  type: VALID_INVITE,
  payload,
});

export const saveCredentials = (payload) => ({
  type: MEMBER_SAVE_CREDENTIALS,
  payload,
});

export const fetchRequestStart = () => ({
  type: FETCH_REQUEST_START,
});
export const fetchRequestSuccess = () => ({
  type: FETCH_REQUEST_SUCCESS,
});
export const fetchRequestFailed = (payload) => ({
  type: FETCH_REQUEST_FAILED,
  payload,
});

export const updateRequestStart = () => ({
  type: UPDATE_REQUEST_START,
});
export const updateRequestSuccess = () => ({
  type: UPDATE_REQUEST_SUCCESS,
});
export const updateRequestFailed = (payload) => ({
  type: UPDATE_REQUEST_FAILED,
  payload,
});

// Registration
export const postRegisterMemeber = (data, inviteKey) => {
  return (dispatch) => {
    dispatch({ type: SEND_REGISTER_START });
    if (inviteKey) {
      inviteKey = `/${inviteKey}`;
    }
    const url = `${apiUrl}/member/register${inviteKey}`;

    return api
      .POST(url, data)
      .then((res) => {
        if (res.success) {
          dispatch({ type: SEND_REGISTER_SUCCEEDED });
          return true;
        }
      })
      .catch((err) => dispatch({ type: SEND_REGISTER_FAILED, payload: err }));
  };
};

// Get Job title list
export const getTitleList = () => {
  return (dispatch) => {
    dispatch({ type: GET_TITLE_LIST_START });
    console.log('Requesting job title list and departments');
    const url = `${apiUrl}/member/register/job-title`;
    api
      .GET(url)
      .then((res) => {
        console.log('Response from job-title list endpoint', res);
        if (res.success) {
          dispatch({ type: GET_TITLE_LIST_SUCCEEDED, payload: res.data });
        } else {
          dispatch({ type: GET_TITLE_LIST_FAILED, payload: res.description });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_TITLE_LIST_FAILED, payload: error });
      });
  };
};

export const getDepartmentList = () => {
  return (dispatch) => {
    dispatch({ type: GET_DEPS_LIST_START });
    console.log('Requesting departments list');
    const url = `${apiUrl}/member/register/departments`;
    api
      .GET(url)
      .then((res) => {
        console.log('Response from department list endpoint', res);
        if (res.success) {
          dispatch({ type: GET_DEPS_LIST_SUCCEEDED, payload: res.data });
        } else {
          dispatch({ type: GET_DEPS_LIST_FAILED, payload: res.description });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_DEPS_LIST_FAILED, payload: error });
      });
  };
};

// Get list of active countries
export const getCountryList = () => {
  return (dispatch) => {
    console.log('Requesting country list');
    dispatch({ type: GET_COUNTRY_LIST_START });
    const url = `${apiUrl}/member/register/country`;
    api
      .GET(url)
      .then((res) => {
        if (res.success) {
          console.log('Response from country list endpoint', res.data);
          dispatch({ type: GET_COUNTRY_LIST_SUCCESS, payload: res.data });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_COUNTRY_LIST_FAILED });
      });
  };
};

// GET list of roles
export const getRoleList = () => (dispatch) => {
  const url = `${apiUrl}/member/role`;
  dispatch(fetchRolesRequestStart());
  api
    .GET(url)
    .then((res) => {
      if (res.success && res.role) {
        dispatch(fetchRolesRequestSuccess(res.role));
      } else {
        dispatch(fetchRolesRequestFailed(res.message));
      }
    })
    .catch((error) => {
      console.log(error);
      dispatch(fetchRolesRequestFailed(error));
    });
};

export const getTZList = () => {
  return (dispatch) => {
    console.log('Requesting TZ list');
    dispatch({ type: GET_TZLIST_START });
    const url = `${apiUrl}/member/register/tzlist`;
    api
      .GET(url)
      .then((res) => {
        if (res.success) {
          console.log('Response from TZ list endpoint', res.data);
          dispatch({ type: GET_TZLIST_SUCCESS, payload: res.data });
        }
      })
      .catch((error) => {
        dispatch({ type: GET_TZLIST_FAILED });
      });
  };
};

// Make back-end send SMS
export const postInitVerification = (contact, type) => {
  return (dispatch) => {
    dispatch({ type: CELL_VERIFICATION_INIT });
    console.log('Requesting verification');
    const url = `${apiUrl}/member/register/verification`;
    const formData = new FormData();
    formData.set('contact_type', type); // type is either email or cell
    formData.set('value', contact); // type is either email or cell

    return api
      .POST(url, formData)
      .then((res) => {
        if (res.success) {
          return {
            success: true,
            totpLength: res.totp_digits_count,
            totpLifetimeSeconds: res.totp_lifetime_seconds,
          };
        } else {
          dispatch({
            type: CELL_VERIFICATION_ERROR,
            payload:
              "An error ocurred. Please verify that the cell phone number you've entered is valid.",
          });
          return {
            success: false,
            description:
              "An error ocurred. Please verify that the cell phone number you've entered is valid.",
          };
        }
      })
      .catch((err) => {
        dispatch({ type: CELL_VERIFICATION_ERROR, payload: err });
        return {
          success: false,
          description: err,
        };
      });
  };
};

export const putVerificationData = (type, contact, token) => {
  return (dispatch) => {
    dispatch({ type: CELL_VERIFICATION_ATTEMPT });
    console.log(`Sending token ${token}`);
    const url = `${apiUrl}/member/register/verification`;
    const formData = new FormData();
    formData.set('contact_type', type);
    formData.set('value', contact);
    formData.set('token', token);

    return api
      .PUT(url, formData)
      .then((res) => {
        dispatch({ type: CELL_VERIFICATION_RESPONSE });
        return res.result;
      })
      .catch((err) =>
        dispatch({ type: CELL_VERIFICATION_ERROR, payload: err })
      );
  };
};

// Get terms and Conditions
// We get T&C for all countries early, and then just swap them when the user changes his/her country
export const getTermsAndConditions = () => {
  // return async (dispatch) =>  {
  // dispatch({ type: GET_TERMS_AND_CONDITIONS_START });

  const url = `${apiUrl}/member/register/terms`;

  return api
    .GET(url)
    .then((res) => {
      console.log('Terms', res.data);
      // dispatch({ type: GET_TERMS_AND_CONDITIONS_SUCCESS, payload: res.data });
      return res.data;
    })
    .catch((err) => console.log(err));
  // };
};

// Promo codes
export const getValidatePromoCode = (promoInput) => {
  return (dispatch) => {
    // dispatch({ type: PROMO_CHECK });
    console.log('Checking promo code', promoInput);
    const url = `${apiUrl}/member/register/promo-code`;
    const formData = new FormData();
    formData.set('promoCode', promoInput);
    return api
      .POST(url, formData)
      .then((res) => {
        if (res.success) {
          return {
            success: true,
            description: res.description,
            promo_code_id: res.promo_code_id,
          };
        } else {
          return {
            success: false,
          };
        }
      })
      .catch((err) => err);
  };
};

// Avatar
export const putAvatar = (formData) => {
  return (dispatch) => {
    console.log('Sending avatar to server');
    const url = `${apiUrl}/member/avatar`;
    dispatch({ type: PUT_AVATAR_UPDATE_START });
    return api
      .PUT(url, formData)
      .then((res) => {
        console.log('Acatar response is', res.data);
        dispatch({ type: PUT_AVATAR_UPDATE_SUCCESS, payload: res.data });
      })
      .catch((error) =>
        dispatch({
          type: PUT_AVATAR_UPDATE_FAILED,
        })
      );
  };
};

export const getNotificationsSetting = () => (dispatch) => {
  const url = `${apiUrl}/member/notifications/setting`;
  dispatch(fetchNotificationsSettingRequestStart());
  return new Promise((resolve) => {
    api
      .GET(url)
      .then((res) => {
        if (res && res.success) {
          dispatch(fetchNotificationsSettingRequestSuccess(res.data.data));
          // const payload = setMemberAlert(res, true, res.message);
          // dispatch(setReduxMemberAlert(payload));
          resolve(true);
        } else {
          const payload = setMemberAlert(res, false);
          dispatch(setReduxMemberAlert(payload));
          dispatch(
            fetchNotificationsSettingRequestFailed({ error: res.message })
          );
          resolve(false);
        }
      })
      .catch((error) => {
        const payload = setMemberAlert(error, false);
        dispatch(setReduxMemberAlert(payload));
        dispatch(fetchNotificationsSettingRequestFailed(error));
        resolve(false);
      });
  });
};

export const putNotificationsSetting = (data) => (dispatch) => {
  const url = `${apiUrl}/member/notifications/setting`;
  const dataString = JSON.stringify(data);
  dispatch(updateNotificationsSettingRequestStart());
  return new Promise((resolve) => {
    api
      .PUT(url, dataString, {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      })
      .then((res) => {
        if (res && res.success) {
          dispatch(updateNotificationsSettingRequestSuccess());
          const payload = setMemberAlert(res, true, res.message);
          dispatch(setReduxMemberAlert(payload));
          resolve(true);
        } else {
          const payload = setMemberAlert(res, false);
          dispatch(setReduxMemberAlert(payload));
          dispatch(
            updateNotificationsSettingRequestFailed({ error: res.message })
          );
          resolve(false);
        }
      })
      .catch((error) => {
        const payload = setMemberAlert(error, false);
        dispatch(setReduxMemberAlert(payload));
        dispatch(updateNotificationsSettingRequestFailed(error));
        resolve(false);
      });
  });
};

export const fetchRolesRequestStart = () => ({
  type: FETCH_ROLES_START,
});
export const fetchRolesRequestSuccess = (payload) => ({
  type: FETCH_ROLES_SUCCESS,
  payload,
});

export const fetchRolesRequestFailed = (payload) => ({
  type: FETCH_ROLES_FAILED,
  payload,
});

export const fetchNotificationsSettingRequestStart = () => ({
  type: FETCH_NOTIFICATIONS_SETTING_START,
});
export const fetchNotificationsSettingRequestSuccess = (payload) => ({
  type: FETCH_NOTIFICATIONS_SETTING_SUCCESS,
  payload,
});
export const fetchNotificationsSettingRequestFailed = (payload) => ({
  type: FETCH_NOTIFICATIONS_SETTING_FAILED,
  payload,
});
export const updateNotificationsSettingRequestStart = () => ({
  type: PUT_NOTIFICATIONS_SETTING_START,
});
export const updateNotificationsSettingRequestSuccess = (payload) => ({
  type: PUT_NOTIFICATIONS_SETTING_SUCCESS,
  payload,
});
export const updateNotificationsSettingRequestFailed = (payload) => ({
  type: PUT_NOTIFICATIONS_SETTING_FAILED,
  payload,
});

export const setReduxMemberAlert = (payload) => ({
  type: SET_MEMBER_ALERT,
  payload,
});

export const autoLogout = () => ({
  type: AUTO_LOGOUT,
});

export const clearAutoLogout = () => ({
  type: CLEAR_AUTO_LOGOUT,
});
